module.exports = __webpack_public_path__ + "media/images/icon_list/pin_pinned_filled-ba0ade3a829bc0254654310e1fbcd6c2.svg";